import { useEffect, useState } from "react";
import {
  Svg,
  Circle,
  Group,
  Line,
  Pos,
  Lab,
  Outer,
  Text1,
  Text2,
  Path,
  CircleGroup,
  LabContainer,
} from "./Overview.label.style";

import { useLocation } from "react-router-dom";
import { useHover } from "hooks/useHover";
import { useAtom } from "jotai";
import { a_labHovered, active_project } from "state/store.global";
import { useClick } from "./Overview.label.click";
import { _project } from "state/store.projects";
import { getFocus, useGet } from "state/jotai";
import { useBreak } from "hooks/useBreak";
import { _bootstrap } from "state/store.bootstrap";
import moment from "moment";
import { KeepScale } from "react-zoom-pan-pinch";

export const MobileLabel = ({
  c,
  sc,
  d,
  l,
  rmode,
  r,
  labelsInfo,
  line,
  angle,
  mobileLabelAxis,
  showLabel,
  setShowLabel,
  hoveredId,
}) => {
    // console.log(r,"rrrrrrrrr")
    // if (c === undefined || r === undefined ){
    //   return <></>;
    // }

    // if(mobileLabelAxis === undefined || angle === undefined || line === undefined) {
    //     return <></>
    // }

    // Continue with the rest of your code if the conditions are met
    // console.log(labelsInfo,"infooo")

  const { pin, pid }         = useGet(active_project);
  const unitStatus           = getFocus(_project, "unitStatuses")?.[pin]?.[pid] ?? [];
  const availableTranslation = 
    unitStatus?.filter((u) => u.ID === 10)?.[0]?.Name ?? "";

    // data for labels
 const projectUnitsStatus = getFocus(_bootstrap, "projects");
 const options            = getFocus(_project, "filteroptions");
 const allUnits           = getFocus(_project, "units");
 const PID                = labelsInfo?.PID;
 const PIN                = labelsInfo?.PIN;
 const unitsCounts        = projectUnitsStatus?.filter((p) => p?.ProjectID === PID);
 const totalUnits         = allUnits?.[pin]?.[pid]?.Units?.reduce((ac, val) => ac += (val?.Data?.ProjectID?.Value === PID ? 1 : 0), 0)
 const vacantUnits        = unitsCounts?.[0]?.NoOfVacantUnits;
 const reservedUnits      = unitsCounts?.[0]?.NoOfReservedUnits;
 const rentedOut          = unitsCounts?.[0]?.NoOfRentedOutUnits;


    // units count through units "KP"
    // const totalUnits = allUnits?.[PIN]?.[PID]?.NumberOfUnits
    // const reservedUnits = (allUnits?.[PIN]?.[PID]?.Units?.filter((u) => u?.Data?.UnitStatusID?.Value == "20").length);
    // const soldUnits = (allUnits?.[PIN]?.[PID]?.Units?.filter((u) => u?.Data?.UnitStatusID?.Value == "40").length);

  const roomSize = options[PIN]?.[PID]?.filter(
    (p) => p?.Label == "Størrelse"
  )?.[0];
  const noOfRooms = options[PIN]?.[PID]?.filter(
    (p) => p?.Label == "Værelser"
  )?.[0];
    // gets move in date from all units
  const moveInDate = allUnits?.[PIN]?.[PID]?.Units?.map(
    (u) => u?.Data?.Indflytningsdato?.UnformattedValue
  );
    // Filter out undefined values
  const validDates = moveInDate?.filter((date) => date);
    // Store all dates in an array
  const datesArray = validDates?.map((date) => ({ date }));

  const hardcodedMoveInDate = 
    allUnits?.[PIN]?.[PID]?.Units?.[0]?.Data?.Indflytningsdatoproperty
      ?.UnformattedValue;

  const here = useLocation().pathname.split("/");

    // const setLabHovered = useAtom(a_labHovered)[1];
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];

  const isOverview = here[here.length - 1] == "isometry";

    // const [hoverRef, isHovered] = useHover();
  const click = useClick();

  const s    = 0.6 / sc === Infinity ? 10 : 0.6 / sc;
  const move = (cx, cy, dir = "-") => ({
    transform: `rotate(${dir}${d} ${cx} ${cy})`,
  });
  const g                           = { ...move(50, 50, "+") };
  const svg                         = { viewBox: "0 0 100 100" };
  const circ1                       = { cx: 0, cy: 0, r: 15, clr: clr };
  const circ2                       = { cx: 0, cy: 0, r: 25, fillOpacity: "0.5", clr: clr };
  const circ3                       = { cx: 0, cy: 0, r: 35, fillOpacity: "0.3", clr: clr };
  const cx                          = r?.[0];
  const cy                          = r?.[1];
  const circleGroup                 = { transform: `translate(50 50)` };
  const path1                       = { d: `M ${cx} ${cy} L 50 ${-l + 50}`, clr: clr };
  const [notHovered, setNotHovered] = useState(true);

  const dl = { d, l, s, notHovered };


    // Property sales type checking
    const salesName = 'Salg'
    const rentalName = 'Leje'

    const porpertyType = {
    sales: false,
    rental: false
    }
   
    let typesDone = false

    // Number of rooms
    let noRmin = Infinity
    let noRmax = 0

    // Number of room size
    let rMinSize = Infinity
    let rMaxSize = 0

    // Move in date
    let today = moment().startOf('day')
    let mDate  = null
    let foundToday = false


    if(Object.keys(allUnits[PIN]?.[PID] || {}).length) {
      for (let i = 0; i < allUnits[PIN]?.[PID]?.Units.length; i++) {
            const val = allUnits[PIN]?.[PID]?.Units[i].Data
            const sID = val.UnitStatusID.Value;
                               
              // Number of rooms
              const noRooms = val.VaerelserAntal.Value
              noRmin = Math.min(noRmin, noRooms)
              noRmax = Math.max(noRmax, noRooms)

              // Number of room size
              const rSize = val.Areal.Value
              if(rSize !== 0) {
                rMinSize = Math.min(rMinSize, rSize)
                rMaxSize = Math.max(rMaxSize, rSize)
              }

              // Move in date
              const cuDate = val.Indflytningsdato?.Value

              if (cuDate && sID === 10) {
                const moveIn = moment(cuDate, 'DD-MM-YYYY', true)

                if (moveIn.isValid()) {
                  // Highest priority: same day as today
                  if (moveIn.isSame(today, 'day')) {
                    mDate = moveIn
                    foundToday = true
                  }

                  // Second priority: nearest future date
                  else if (!foundToday && moveIn.isAfter(today, 'day')) {
                    if (!mDate || moveIn.isBefore(mDate, 'day')) {
                      mDate = moveIn
                    }
                  }
                }
              }
           
              if (porpertyType.rental && porpertyType.sales) {
                typesDone = true // stop checking types, NOT the loop
              }

              if(!typesDone) {
                  if(val.SalesTypeLejelejlighed.Value) {
                    porpertyType.rental = true
                  }else if(val.SalesTypeEjerlejlighed.Value) {
                    porpertyType.sales = true
                  }
              }
          }
    }
 
  // Rule 3: if mDate is still null → send null to frontend
  const finalMdate = mDate ? mDate.format('DD-MM-YYYY') : null

  const saletype =
    porpertyType.sales && porpertyType.rental
      ? `${rentalName} & ${salesName}`
      : porpertyType.sales
      ? salesName
      : porpertyType.rental ? rentalName : '';
 const projectExtraInfo = {
    Neptunus: {
      name: "NEPTUNUS",
      moveIn: "Indflytning 2027",
    },
    Dannebroge: {
      name: "DANNEBROGE",
      moveIn: "Indflytning 2026",
    },
    Gyldenløve: {
      name: "Gyldenløve",
      moveIn: "Indflytning Marts 2026",
    },
    Skibet: {
        name: "Skibet",
    },
    Broen: {
        name: "Broen",
    },
   "Hvide Falk": {
      name: "Hvide Falk",
      moveIn: "Klar til indflytning",
    },
    Postillionen: {
      name: "Postillionen",
      moveIn: "Udsolgt",
    }
    // Add more projects here
  };
  const currentProjectInfo = projectExtraInfo[labelsInfo?.Presentation];

  useEffect(() => {
    if (hoveredId == labelsInfo?.URLSafe) {
      setNotHovered(false);
    } else {
      setNotHovered(true);
    }
  }, [hoveredId]);

  if (isOverview && !rmode)
    return (
      <>
        <Pos c={c} style={{
           zIndex: hoveredId === labelsInfo?.URLSafe ? 10 : 5,
        }}>
          <div style={{ transform: `scale(${1*s + 0.3})` }}>
            <Svg {...svg}>
              <CircleGroup {...circleGroup}>
                <Circle {...circ1}></Circle>
                <Circle {...circ2}></Circle>
                <Circle {...circ3}></Circle>
              </CircleGroup>
            </Svg>

          {hoveredId == labelsInfo?.URLSafe ? (
            <Outer
              {...dl}
              xAxis = {mobileLabelAxis?.[0]}
              yAxis = {mobileLabelAxis?.[1]}
            >
              <LabContainer
                {...dl}
                clr = {clr}
                  // ref     = {hoverRef}
                onClick = {null}
              >
                <Text2
                className = "paragraph2-regular"
                style     = {{
                    borderBottom: "2px solid #fff",
                    padding     : "8px 16px",
                  }}
                >
                  {labelsInfo?.Presentation == "c4"
                    ? buttonsLabel?.filter(
                        (btn) => btn.UILabelProperty === "Enhedertilleje"
                      )[0]?.Label
                    : "Boliger til leje"}
                </Text2>
                <Lab   clr = {clr}>
                <Text1 s   = {s}>{labelsInfo?.Presentation}</Text1>
                  {/* <Text2 s = {s}>{`${labelsInfo?.available_Units} ${availableTranslation?.toLowerCase()}`} { buttonsLabel?.filter( (btn) => btn.UILabelProperty === "boliger"
                  )[0]?.Label?.toLowerCase()
                }</Text2> */}
                  <Text2 className = "paragraph2-regular" >
                    {totalUnits}&nbsp;
                    {totalUnits > 1
                      ? buttonsLabel
                          ?.filter(
                            (btn) => btn.UILabelProperty === "boliger"
                          )[0]
                          ?.Label?.toLowerCase()
                      :  buttonsLabel
                          ?.filter((btn) => btn.UILabelProperty === "bolig")[0]
                          ?.Label?.toLowerCase()}
                  </Text2>
                  <Text2 className = "paragraph2-regular" >
                    {labelsInfo?.available_Units}{" "}
                    {labelsInfo?.available_Units > 1
                      ? buttonsLabel?.filter(
                          (btn) => btn.UILabelProperty === "Ledige"
                        )[0]?.Label
                      : availableTranslation?.toLowerCase()}
                  </Text2>
                  {/* <Text2>{reservedUnits} reserved</Text2>
              <Text2>{rentedOut} sold</Text2> */}
                  {
                rMaxSize && <Text2 className="paragraph2-regular">{`${rMinSize} - ${rMaxSize} ${roomSize?.Postfix}`}</Text2>
                }
                {
                  noRmax &&  <Text2 className="paragraph2-regular"> 
                  {`${noRmin} - ${noRmax}`}{" "}
                  {noRmax > 1
                    ? buttonsLabel?.filter((btn) => btn.UILabelProperty === "værelser")[0]?.Label
                    : buttonsLabel?.filter((btn) => btn.UILabelProperty === "værelse")[0]?.Label}
                </Text2>
                }
                {finalMdate && (
                  <Text2 className="paragraph2-regular">
                    {buttonsLabel?.filter((btn) => btn.UILabelProperty === "Indflytning")[0]?.Label}: {finalMdate}
                  </Text2>
                )}
                  <button
                    className = "paragraph2-regular"
                    onClick   = {() => {
                      click(labelsInfo);
                      setShowLabel(false);
                    }}
                    style={{
                      padding        : "4px 16px",
                      borderRadius   : "6px",
                      border         : "1px solid #D1D1D1",
                      backgroundColor: "#FFF",
                      color: "#000",
                    }}
                  >
                    Vælg
                  </button>
                </Lab>
              </LabContainer>
            </Outer>
          ) : (
            <Outer
              {...dl}
              xAxis = {mobileLabelAxis?.[0]}
              yAxis = {mobileLabelAxis?.[1]}
            >
             <LabContainer {...dl} clr                = {clr} onClick              = {null}>
                 {/* Extra project name */}
                {currentProjectInfo?.name && (
                  <Text1
                    className="paragraph2-regular"
                    style={{ padding: "8px 16px 4px 16px" }}
                  >
                    {currentProjectInfo.name}
                  </Text1>
                )}

               


                {/* Extra move-in date */}
                {currentProjectInfo?.moveIn && (
                  <Text2
                    className="paragraph2-regular"
            style={{ padding:  labelsInfo?.URLSafe === 'neptunus' || labelsInfo?.URLSafe === 'postillionen'? "4px 16px 8px 16px" : "4px 16px" }}
                  >
                    {currentProjectInfo.moveIn}
                  </Text2>
                )}
             {
                  labelsInfo?.URLSafe !== 'neptunus' && labelsInfo?.URLSafe !== "postillionen" && ( <Text2
                  className="paragraph2-regular"
                  style={{ padding: "4px 16px 8px 16px" }}
                >
                  Boliger til {saletype}
                </Text2>
                  )
                }
              </LabContainer>
            </Outer>
          )}
          </div>
        </Pos>
      </>
    );
};

const style = {
  zIndex        : 1000,
  background    : "black",
  color         : "white",
  height        : 100,
  width         : 220,
  position      : "absolute",
  display       : "flex",
  justifyContent: "center",
  alignItems    : "center",
  fontSize      : "1.6rem",
};
